const trimTrailingSlashes = (value: string) => value.replace(/\/+$/, "");

export function formatRoute(route?: string) {
	return route ? (route.startsWith("/") ? route : `/${route}`) : "/";
}

export const getBaseCMSUrl = () => {
	const baseUrl = process.env.UMBRACO_CMS_BASE_URL;
	return baseUrl ? trimTrailingSlashes(baseUrl) : undefined;
};
